import _ from 'underscore';
import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

export const withError = (Component) => {
  const HOC = React.memo((props) => {
    const { validationProps } = props;
    const {
      passiveMessages,
      alwaysShowError,
      onValidate,
      suppressError,
    } = validationProps;

    const [state, setState] = useState({ messages: [], isDirty: false });

    const onValidateFn = useCallback((item) => {
      if (_.isFunction(onValidate)) {
        onValidate(item);
      }
      setState({
        messages: item.messages,
        isDirty: item.isDirty,
      });
    }, [onValidate]);

    const errorMessage = useMemo(() => {
      if (!suppressError
        && (alwaysShowError || state.isDirty || !_.isEmpty(passiveMessages)
        || !_.isEmpty(state.messages))) {
        const errorMessages = [...state.messages, ..._.result(validationProps, 'passiveMessages', [])];
        const err = errorMessages.slice(0, 1);
        return _.isEmpty(err) ? null : err;
      }
      return null;
    }, [alwaysShowError, suppressError, passiveMessages, state, validationProps]);

    return (
      <Component
        {...props}
        errorMessage={_.isEmpty(errorMessage) ? null : errorMessage}
        validationProps={{ ...validationProps, onValidate: onValidateFn }}
      />
    );
  });


  HOC.propTypes = {
    validationProps: PropTypes.shape({
      onValidate: PropTypes.func,
      alwaysShowError: PropTypes.bool,
      passiveMessages: PropTypes.arrayOf(PropTypes.string),
      suppressError: PropTypes.bool,
    }),
  };

  HOC.defaultProps = {
    validationProps: {
      onValidate: _.noop,
      alwaysShowError: false,
      passiveMessages: [],
      suppressError: false,
    },
  };

  return HOC;
};
